import styles from './FullWidthImage.module.scss'
interface FullWidthImageProps {
  text?: string;
}
const FullWidthImage: React.FC<FullWidthImageProps> = ({ text }) => {
  return (
    <section className={styles.fullWidthImg} style={{ backgroundImage: 'url(/images/imageBg.png)' }}>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-xl-6 px-4'>
            {text && <div dangerouslySetInnerHTML={{ __html: text }} />}
          </div>
          <div className='col-12 px-4'>
            <img className='img-fluid d-none d-md-block' src="/images/insideImg.png" alt="" />
            <img className='img-fluid d-md-none d-block mt-5' src="/svgs/insideImgMobile.svg" alt="" />
          </div>
        </div>
      </div>
    </section>
  )
}
export default FullWidthImage;